// @ts-check
import { Skeleton } from "./skeleton";
import { BannerContent, Container, ContentView } from "./styles";
import { usePanel } from "./viewModel/usePanel";
import { useHistory } from "react-router-dom";
import { DateTime } from "luxon";
import { HeaderCard } from "./cards/header";
import { RdmCard } from "./cards/rdm";
import { UsersCard } from "./cards/users";
import { RdmModal } from "../RDM/components/RdmModal";
import { RemoveRdmModal } from "../RDM/components/RemoveRdmModal";
import { RdmUserModal } from "./components/rdmUserModal";
import { RemoveRdmUserModal } from "./components/RemoveRdmUserModal";
import Banner from "../../assets/icons/Banner";

/**
 * @typedef {Object} RdmData
 * @property {string} createdAt
 * @property {string} updatedAt
 * @property {number} positives
 * @property {number} negatives
 * @property {string} description
 */

/**
 * @param {Rdm} data
 * @returns {RdmData}
 */
function getRdmData(data) {
  return {
    createdAt: data?.createdAt
      ? DateTime.fromISO(data.createdAt).toFormat("dd/MM/yyyy HH:mm")
      : "-",
    updatedAt: data?.updatedAt
      ? DateTime.fromISO(data.updatedAt).toFormat("dd/MM/yyyy HH:mm")
      : "-",
    positives:
      data.rdmUsers.reduce((acc, user) => acc + user.positives, 0) ?? 0,
    negatives:
      data.rdmUsers.reduce((acc, user) => acc + user.negatives, 0) ?? 0,
    description: data?.description ?? "-",
  };
}

export default function RdmPanel(location) {
  const rdmId = location.match.params.id;
  const history = useHistory();
  const {
    userPermissions,
    currentUser,
    data,
    loading,
    users,
    handleCollapse,
    isEditUser,
    collapses,
    options,
    form,
    formUser,
    handleSubmit,
    handleSubmitUser,
    handleOpenUserModal,
    handleRemoveUser,
    onCloseRemoveUserModal,
    onCloseModal,
    onCloseModalUser,
    onDelete,
    openModal,
    title,
    openUserRemoveModal,
    openRemoveModal,
    openUserModal,
    toDisableModal,
    toDisableModalUser,
  } = usePanel(rdmId);

  const rdmData = data ? getRdmData(data) : null;

  return (
    <>
      <BannerContent>
        <Banner />
      </BannerContent>
      <Container>
        <ContentView>
          {loading ? (
            <Skeleton />
          ) : (
            <>
              <HeaderCard
                pushBack={() => history.goBack()}
                title={data?.title}
              />
              <RdmCard
                handleCollapse={handleCollapse}
                collapses={collapses}
                rdmData={rdmData}
                options={options.rdm}
                userPermissions={userPermissions}
              />
              <UsersCard
                handleCollapse={handleCollapse}
                onOpenAddModal={() => handleOpenUserModal()}
                collapses={collapses}
                data={data}
                options={options.users}
                userPermissions={userPermissions}
              />
            </>
          )}
        </ContentView>
      </Container>
      <RdmModal
        title="Editar RDM"
        onSubmit={handleSubmit}
        form={form}
        isOpen={openModal}
        onClose={onCloseModal}
        disabled={toDisableModal()}
      />
      <RemoveRdmModal
        title={title}
        isOpen={openRemoveModal}
        onClose={onCloseModal}
        onConfirm={onDelete}
      />
      <RdmUserModal
        users={users}
        onSubmit={handleSubmitUser}
        form={formUser}
        isOpen={openUserModal}
        onClose={onCloseModalUser}
        disabled={toDisableModalUser()}
        isEdit={isEditUser}
        rdm={data}
        title={isEditUser ? "Editar Usuário" : "Novo Usuário"}
      />
      <RemoveRdmUserModal
        title={currentUser?.userData?.username ?? ""}
        isOpen={openUserRemoveModal}
        onClose={onCloseRemoveUserModal}
        onConfirm={handleRemoveUser}
      />
    </>
  );
}
